import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle-fields"
export default class extends Controller {
  connect() {
    const element = this.element;
    const id = element.id;
    this.toggleFieldsVisibility(id);
    element.addEventListener("change", () => this.toggleFieldsVisibility(id));
  }

  toggleFieldsVisibility(id) {
    const dependencyElements = document.querySelectorAll(`[data-dependency="${id}"]`);

    dependencyElements.forEach((el) => {
      const targetId = el.dataset.dependency;
      const dependencyValue = el.dataset.dependencyvalue || 'null';
      const values = dependencyValue.includes(",") ? dependencyValue.split(",") : [dependencyValue];
      const condition = el.dataset.dependencycondition;
      const targetInput = document.getElementById(targetId);
      const targetValue = targetInput?.value || 'null';

      const input = el.querySelector("input, select, textarea");

      const show = () => {
        el.style.display = "";
        if (input) input.disabled = false;
      };

      const hide = () => {
        el.style.display = "none";
        if (input) {
          input.disabled = true;
          input.value = "";
        }
      };

      switch (condition) {
        case "Not-equals":
        case "Does not contain":
          if (targetValue !== "" && !values.includes(targetValue)) {
            show();
          } else {
            hide();
          }
          break;
        case "Equals":
        case "Contains":
          if (targetValue !== "" && values.includes(targetValue)) {
            show();
          } else {
            hide();
          }
          break;
        case "Starts with":
          if (
            targetValue !== "" &&
            values.some((val) => targetValue.startsWith(val))
          ) {
            show();
          } else {
            hide();
          }
          break;
        case "Does not start with":
          if (
            targetValue !== "" &&
            !values.some((val) => targetValue.startsWith(val))
          ) {
            show();
          } else {
            hide();
          }
          break;
        default:
          // fallback: hide
          hide();
      }
    });
  }
}
